// extracted by mini-css-extract-plugin
export default {"users":"style_users__-3gPw","edit":"style_edit__1pmZK"};